export class ScheduledNotification {
  name: string;
  description: string;
  id: string;
  schema: any;
  metadata: any;
  cronExpression: string;
}
